import { ActionService } from '@acme/api';
import { useCertificates, useUser } from '@acme/domains';
import { useState } from 'react';
import { getDetachedSignature } from '../../sign';

interface UsePdfFileResult {
  blob: Blob | null;
  arrayBuffer: ArrayBuffer | null;
  isLoading: boolean;
  isDocumentLoading: boolean;
  error: string | null;
  errorLoadFile: string | null;
  loadPdfFile: () => void;
  handleSignAction: (actionId: string) => void;
  getDocument: (actionId: string) => void;
}

interface usePdfFileProps {
  onSuccessSign?: () => void;
}

export const usePdfFile = (props?: usePdfFileProps): UsePdfFileResult => {
  const { validCurrentCertificate } = useCertificates();
  const { user } = useUser();

  const [blob, setBlob] = useState<Blob | null>(null);
  const [isDocumentLoading, setIsDocumentLoading] = useState(false);

  const [arrayBuffer, setArrayBuffer] = useState<ArrayBuffer | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [errorLoadFile, setErrorLoadFile] = useState<string | null>(null);

  const loadPdfFile = async () => {
    setIsLoading(true);
    setErrorLoadFile(null);

    if (blob) {
      try {
        console.log('loadPdfFile');
      } catch (error) {
        console.error('Error loading PDF:', error);
        setErrorLoadFile('Ошибка загрузки PDF файла');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const getDocument = async (actionId: string) => {
    if (actionId && !isDocumentLoading && !blob) {
      setIsDocumentLoading(true);
      try {
        const pdfBlob = await ActionService.getApiV1ActionDocument({
          id: actionId!,
        });

        if (pdfBlob) {
          try {
            const buffer = await pdfBlob.arrayBuffer();
            setArrayBuffer(buffer);
          } catch (error) {
            console.error('Error loading PDF:', error);
            setError('Ошибка загрузки PDF файла');
          } finally {
            setIsDocumentLoading(false);
          }

          setBlob(pdfBlob);
        }

        setIsDocumentLoading(false);
      } catch (error) {
        console.log(error);
      } finally {
        setIsDocumentLoading(false);
      }
    }
  };

  const handleSignAction = async (actionId: string) => {
    if (actionId && arrayBuffer && user) {
      const certificate = validCurrentCertificate(user);

      if (certificate) {
        const detachedSignatureBase64t = await getDetachedSignature(
          arrayBuffer!,
          certificate
        );

        const res = await ActionService.postApiV1ActionSign({
          id: actionId,
          requestBody: {
            detachedSignatureBase64t,
          },
        });

        if (res.isSuccess) {
          props?.onSuccessSign?.();
        }
      }
    }
  };

  return {
    blob,
    arrayBuffer,
    isLoading,
    error,
    errorLoadFile,
    loadPdfFile,
    getDocument,
    isDocumentLoading,
    handleSignAction,
  };
};
